export default "__VITE_ASSET__3a5653ca__"